export default "/assets/images/the-basic-breather.5ccdbf68a9b2bc3f.png";